import {useQueries} from "@tanstack/react-query";
import camerasService from "../../../services/cameras-service";

const UseFetchData = (code) => {
    const queries = useQueries({
        queries: [
            {
                queryFn: () => camerasService.getProjectAndNext(code),
                queryKey: ["project", {code}],
                enabled: code !== undefined
            },
            {
                queryFn: () => camerasService.hash(),
                queryKey: ["hash"]
            }
        ]
    });

    return {
        project: queries[0].data,
        hash: queries[1].data
    }
};

export default UseFetchData;